/**
 * A modulo operator for JavaScript (works different than the remainder operator %).
 * An everyday example is the clock in which the number of hours range from 0 to 23
 * and then restart at 0 the next day. Another example is browsing through the entries
 * of a list component with a finite amount of entries, skipping back to the start
 * after reaching the end.
 * @param a Any defined (rational) number
 * @param n A positive integer
 * @returns a number that is at least 0 and less than n.
 */
export var mod = function (a, n) { return ((a % n) + n) % n; };
/**
 * Ensures a number a number is at least `min` or at most `max`.
 * @param value: The value that should be returned unless it is less than `min` or more than `max`
 * @param min: The lowest possible value the function should return
 * @param max: The highest possible value the function should return
 * @returns `min` if `value` is `min` or lower,
 * @returns `max` if `value` is `max` or higher,
 * @returns `value` otherwise.
 */
export var clamp = function (value, min, max) {
    return Math.min(Math.max(value, min), max);
};
//# sourceMappingURL=helpers.js.map